(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["evolved-cart-layout"] && !Shopify.designMode) return;
  try {
    (() => {
  const key = 'evolved.cart-offer.dismissed.v1';
  let dismissed = false;
  try { dismissed = sessionStorage.getItem(key) === '1'; } catch (_) {}
  const hideOffer = offer => {
    if (!offer) return;
    if (typeof offer.closeChoices === 'function') offer.closeChoices();
    offer.dataset.evDismissed = 'true';
    offer.hidden = true;
  };
  if (!customElements.get('evolved-cart-offer-dismiss')) {
    customElements.define('evolved-cart-offer-dismiss', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const offer = this.closest('evolved-cart-offer');
        if (dismissed) hideOffer(offer);
        this.querySelector('button')?.addEventListener('click', () => {
          if (!offer || offer.querySelector('[data-ev-add][aria-busy="true"]')) return;
          const drawer = offer.closest('#cart-drawer');
          const checkout = drawer?.querySelector('[name="checkout"]') || document.querySelector('.shopify-section--main-cart [name="checkout"]');
          dismissed = true;
          try { sessionStorage.setItem(key, '1'); } catch (_) {}
          document.querySelectorAll('evolved-cart-offer').forEach(hideOffer);
          checkout?.focus({preventScroll:true});
        }, {signal:this.controller.signal});
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["evolved-collection-ui"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('evolved-collection-links')) {
  customElements.define('evolved-collection-links', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const {signal} = this.controller;
      const schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.buildLinks());
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, {once:true,signal});
      else schedule();
      for (const name of ['shopify:section:load','shopify:section:unload','shopify:section:reorder']) document.addEventListener(name, schedule, {signal});
    }
    buildLinks() {
      if (!this.isConnected) return;
      const main = this.closest('main') || document.getElementById('main');
      const nav = this.querySelector('nav');
      if (!main || !nav) return;
      const targets = [], seen = new Set();
      for (const section of main.querySelectorAll('.ev-guide__section,.shopify-section--featured-collection')) {
        const heading = section.querySelector('.ev-guide__heading > h2,.evolved-featured-collection__heading');
        if (!heading || heading.closest('[hidden],[inert]') || section.hidden) continue;
        const raw = heading.textContent.trim();
        const id = section.id || heading.id || section.closest('.shopify-section')?.id;
        if (!raw || !id || seen.has(id)) continue;
        const guidance = section.querySelector('[data-ev-nav-label]');
        targets.push({id,label:guidance?.dataset.evNavLabel || raw,icon:guidance?.querySelector('[data-ev-nav-icon] svg')});
        seen.add(id);
      }
      if (targets.length < 2) { nav.replaceChildren(); this.hidden = true; return; }
      const fragment = document.createDocumentFragment();
      for (const target of targets) {
        const link = document.createElement('a');
        link.setAttribute('href','#' + encodeURIComponent(target.id));
        if (target.icon) {
          const icon = target.icon.cloneNode(true);
          icon.removeAttribute('id');
          icon.setAttribute('aria-hidden','true');
          icon.setAttribute('focusable','false');
          link.append(icon);
        }
        const text = document.createElement('span');
        text.textContent = target.label;
        link.append(text); fragment.append(link);
        document.getElementById(target.id)?.classList.add('ev-collection-jump-target');
      }
      nav.replaceChildren(fragment);
      this.hidden = false;
    }
    disconnectedCallback() { this.controller?.abort(); cancelAnimationFrame(this.frame); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
